import { axiosInstance } from 'config';
import { GetSellingCompanyResponse } from './selling-companies.model';

class SellingCompaniesAPI {
  getSellingCompanies() {
    return axiosInstance
      .get<GetSellingCompanyResponse>('/servicios_fijos/v1/selling_companies')
      .then(({ data }) => data.companies);
  }
}

export default new SellingCompaniesAPI();
